// Rolling N-year outcomes — the investor question "whenever you entered,
// what did an N-year hold deliver?" Every contiguous N-year span of the
// displayed years becomes one row, compounded from the SAME audited yearly
// numbers the table already shows. Rolling (every entry point) — never
// fixed buckets, whose verdicts depend on arbitrary chunk boundaries.

// yearly: {year: pct|null}; years: number[]; n >= 1
// -> [{ startYear, endYear, label, value }] ascending by endYear.
export function rollingWindows(yearly, years, n) {
  const asc = [...years].map(Number).sort((a, b) => a - b);
  const out = [];
  for (let i = 0; i + n <= asc.length; i++) {
    const span = asc.slice(i, i + n);
    if (span[n - 1] - span[0] !== n - 1) continue; // must be contiguous years
    let mult = 1;
    let ok = true;
    for (const y of span) {
      const v = yearly[y];
      if (v == null) { ok = false; break; }
      mult *= 1 + v / 100;
    }
    if (!ok) continue;
    out.push({
      startYear: span[0], endYear: span[n - 1],
      label: n === 1 ? String(span[0]) : `${span[0]}–${String(span[n - 1]).slice(2)}`,
      value: (mult - 1) * 100,
    });
  }
  return out;
}

// The pitch numbers: worst / median any-entry outcome for the horizon.
export function windowStats(windows) {
  if (!windows.length) return null;
  const vals = windows.map(w => w.value).sort((a, b) => a - b);
  const mid = Math.floor(vals.length / 2);
  const median = vals.length % 2 ? vals[mid] : (vals[mid - 1] + vals[mid]) / 2;
  const worst = windows.reduce((a, w) => (w.value < a.value ? w : a));
  return { worst: worst.value, worstLabel: worst.label, median, count: windows.length };
}

// A persisted horizon that no longer exists (5 Years was dropped
// 2026-09-24 — Apal: filters fit one line) falls back to Yearly.
export const sanitizeHorizon = (v) => (HORIZON_OPTIONS.some(o => o.key === v) ? v : 1);
// Short labels keep the filter bar on one line (Apal 2026-09-25:
// "Horizon could be minimized by 1y, 2y and 3y something like that").
export const HORIZON_OPTIONS = [
  { key: 1, label: '1Y' },
  { key: 2, label: '2Y' },
  { key: 3, label: '3Y' },
];
